import BookingSummary from "./BookingSummary";
import { useApartmentSummaryBaseProps } from "../common/components/BookingOverview/useApartmentSummaryBaseProps";
import { useEnsureApartmentDetails } from "../common/hooks/useEnsureApartmentDetails";

const BookingOverview = () => {
  // Re-load the room details here too: after a refresh on this step, URL
  // hydration restores the selected venue but nothing else re-ran the
  // overview's fetch — the summary then had no room name, no thumbnail and
  // no group id for the submit call.
  useEnsureApartmentDetails();
  // Venue's BookingSummary signature doesn't include pricingDiscounts; strip
  // it so the spread doesn't pass an unexpected prop.
  const { pricingDiscounts: _ignored, ...baseProps } =
    useApartmentSummaryBaseProps();
  return <BookingSummary {...baseProps} />;
};

export default BookingOverview;
